.empty-state {
    padding: 32px 0;
    text-align: center;
}
